import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button, Card, CardBody, Container } from 'reactstrap';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message || 'Unexpected error' };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[TLN Connect ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className="py-5">
          <Card>
            <CardBody className="text-center py-5">
              <h4 className="mb-2">Something went wrong</h4>
              <p className="text-muted mb-4">{this.state.message}</p>
              <Button
                color="primary"
                onClick={() => {
                  this.setState({ hasError: false, message: '' });
                  window.location.assign('/');
                }}
              >
                Reload
              </Button>
            </CardBody>
          </Card>
        </Container>
      );
    }
    return this.props.children;
  }
}
